import { render, staticRenderFns } from "./preinformtext.vue?vue&type=template&id=3d631054&"
import script from "./preinformtext.vue?vue&type=script&lang=js&"
export * from "./preinformtext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports